import { useBreadcrumbsContext } from "./useBreadcrumbsContext.js";
import { useCallback, useMemo } from "react";
import { Breadcrumbs } from "@therms/atalaya";
import { jsx } from "react/jsx-runtime";
//#region src/components/Breadcrumbs/Breadcrumb.tsx
function Breadcrumb({ children, link }) {
	const { isCurrentLinkMatcher, onNavigate } = useBreadcrumbsContext();
	const handleBreadcrumbClick = useCallback((_link) => {
		if (_link && onNavigate) onNavigate(_link);
	}, [onNavigate]);
	const isClickable = useMemo(() => {
		if (!isCurrentLinkMatcher || !link) return false;
		return !isCurrentLinkMatcher(link);
	}, [link, isCurrentLinkMatcher]);
	return /* @__PURE__ */ jsx(Breadcrumbs.Crumb, {
		clickable: isClickable,
		onClick: () => handleBreadcrumbClick(link),
		children: children ?? "..."
	});
}
//#endregion
export { Breadcrumb };

//# sourceMappingURL=Breadcrumb.js.map